import { filterOptions } from '@/utils/query-base'
import { formatSapDate } from '@/mixins/index'
// const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
// const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])
export const pageSearch = {
  'kotabnr': {
    title: '条件表',
    type: 'select',
    equation: all,
    dictionary: 'A0101',
    unSearchRole: ['WLY023', 'WLY024']
  }
}

export default {
  'product_id': {
    title: '产品编号',
    type: 'input',
    equation: all,
    slot: true,
    width: 180
  },
  'short_text': {
    title: '产品描述',
    type: 'input',
    equation: all,
    width: 400
  },
  'zzfld00001h': {
    describe: true,
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale',
    unSearchRole: ['WLY023', 'WLY024']
  },
  'partner': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    }
  },
  'name_org1': {
    title: '客户名称',
    type: 'input',
    equation: all,
    width: 250
  },
  'zpric_type': {
    describe: true,
    title: '价格类型',
    type: 'select',
    equation: city,
    dictionary: 'A0020'
  },
  'kbetr': {
    title: '价格金额',
    xlsxFmt: {
      t: 'n'
    }
  },
  // 'release_status': {
  //   describe: true,
  //   title: '发布状态',
  //   type: 'select',
  //   equation: city,
  //   dictionary: 'pricestatus'
  // },
  'zindex': {
    title: '生效节点',
    type: 'input',
    equation: all
  },
  'date_from': {
    title: '有效日期起',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'date_to': {
    title: '有效日期截止',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'remark': {
    title: '备注',
    type: 'input',
  }
}



// WEBPACK FOOTER //
// ./src/views/price-manage/config/priceQuery.js